/*
    存储接口请求的域名
*/

import http from "./index";

let url = ''
let imgUrl = ''
let LargeScreen = '';
/*第一层if判断生产环境和开发环境*/
// if (process.env.NODE_ENV === 'development') {
    url = process.env.VUE_APP_BASE_URL; //正式
    LargeScreen = process.env.VUE_APP_LARGE_SCERRN;
    imgUrl = process.env.VUE_APP_IMG_URL
// }

// 登陆
export const login = (params) => http.postRequest(url + "/login/web/signIn", params);
//登录滑块验证
export const ImgAuth = (params) => http.postRequest(url + "/login/web/imgAuth", params);
//回去图片滑块
export const slideImgCoden = (params) => http.getRequest(url + "/login/web/slideImgCode", params);
//文件上传
export const fileUpload = (params) => http.postFileUpload(url + "/file/upload", params);
// 文档导入
export const excelUpload = (params) => http.postFileUpload(url + "/user/excel/import", params);

// 获取字典
async function getDict(code) {
    return new Promise((resolve) => {
        http.getRequest(url + "/dict/select?code=" + code).then((res) => {
            console.log(code, res.data.data)
            resolve(res.data.data);
        });
    });
}

// 获取全部员工
async function getUserList(name) {
    return new Promise((resolve) => {
        http.getRequest(url + "/user/list?name=" + name || "").then((res) => {
            resolve(res.data.data);
        });
    });
}

// 获取巡检完成情况与巡检异常情况
export const getEndAndErrorData = (params) => http.getRequest(url + "/patrolInspectionTotalData/getEndAndErrorData", params);
// 获取人员巡检排名
export const getUserTop = (params) => http.getRequest(url + "/patrolInspectionTotalData/getUserTop", params);
// 获取设备/资产异常排名
export const getDeviceTop = (params) => http.getRequest(url + "/patrolInspectionTotalData/getDeviceTop", params);
// 最新巡检记录查询（只查前十条）
export const findPatrolRecordNew = (params) => http.getRequest(url + "/patrolInspectionTotalData/findPatrolRecordNew", params);
// 过久未执行的巡检任务（只查前十条）
export const findLongTimeTask = (params) => http.getRequest(url + "/patrolInspectionTotalData/findLongTimeTask", params);
export default {
    url,
    login,
    slideImgCoden,
    ImgAuth,
    fileUpload,
    getDict,
    excelUpload,
    getUserList,
    LargeScreen,
    imgUrl,
    getEndAndErrorData,
    getUserTop,
    getDeviceTop,
    findPatrolRecordNew,
    findLongTimeTask
};
